import { useAnalytics } from '../context/AnalyticsContext';

const PALETTE = [
	'#2563EB','#059669','#D97706','#7C3AED','#DC2626',
	'#0891B2','#65A30D','#C2410C','#9333EA','#0369A1',
];

function getInitials(name) {
	if (!name) return '?';
	return name.split(' ').filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';
}

export default function RecentLog() {
	const { state } = useAnalytics();
	const {
		recentLog, filteredRecentLog, dateRecentLog,
		filterType, selectedModule, selectedUser, selectedRole,
		selectedDate, loading, filterLoading, dateHourlyLoading,
	} = state;

	// Priority: date drill-down > any active filter > global
	const hasDate    = !!selectedDate;
	const isFiltered = !!filterType;

	const data = hasDate    ? dateRecentLog     :
	             isFiltered ? filteredRecentLog :
	             recentLog;

	const busy = hasDate    ? dateHourlyLoading :
	             isFiltered ? filterLoading     :
	             loading;

	const emptyMsg = hasDate
		? `No records for ${new Date(selectedDate + 'T12:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
		: filterType === 'module' ? `No records for "${selectedModule?.label}"`
		: filterType === 'user'   ? `No records for "${selectedUser?.label}"`
		: filterType === 'role'   ? `No records for role "${selectedRole?.label}"`
		: 'No records yet';

	if (busy) return <div style={S.empty}>Loading…</div>;
	if (!data?.length) return <div style={S.empty}>{emptyMsg}</div>;

	return (
		<div style={S.list}>
			{data.map((entry, i) => {
				const col      = PALETTE[i % PALETTE.length];
				const name     = entry.userFullName ?? entry.userId ?? '—';
				const initials = getInitials(name);
				const time     = new Date(entry.accessedAt);
				const dateStr  = time.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
				const timeStr  = time.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

				return (
					<div key={entry.id ?? i} style={S.row}>
						<div style={{ ...S.avatar, background: col + '15', color: col }}>{initials}</div>
						<div style={S.info}>
							<div style={S.modName}>{entry.moduleName ?? entry.moduleId ?? '—'}</div>
							<div style={S.userName}>{name}</div>
						</div>
						<div style={S.timeCol}>
							<div style={S.timeDate}>{dateStr}</div>
							<div style={S.timeHour}>{timeStr}</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}

const S = {
	list:     { overflowY: 'auto', maxHeight: 290 },
	row: {
		display: 'flex', alignItems: 'center', gap: 10,
		padding: '8px 0', borderBottom: '1px solid #F1F5F9',
	},
	avatar: {
		width: 32, height: 32, borderRadius: 9, flexShrink: 0,
		display: 'flex', alignItems: 'center', justifyContent: 'center',
		fontSize: 11, fontWeight: 700,
	},
	info:     { flex: 1, minWidth: 0 },
	modName:  { fontSize: 13, fontWeight: 600, color: '#1E293B', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
	userName: { fontSize: 11, color: '#94A3B8', marginTop: 1 },
	timeCol:  { textAlign: 'right', flexShrink: 0, minWidth: 80, paddingRight: 10 },
	timeDate: { fontSize: 11, color: '#64748B', fontWeight: 500, whiteSpace: 'nowrap' },
	timeHour: { fontSize: 11, color: '#94A3B8', whiteSpace: 'nowrap' },
	empty:    { color: '#94A3B8', textAlign: 'center', padding: '32px 0', fontSize: 13 },
};